import React, {useState} from 'react';
import {useQuery} from '@tanstack/react-query';
import useMe from '../../../hooks/useMe';
import {Alert, AlertIcon, Box, Button, VStack} from 'components/ui/chakra';
import PaymentController from 'puddleglum/api/patient/PaymentController';

const RecentPayments = () => {
	const [showAll, setShowAll] = useState(false);
	const {me} = useMe();
	const {data: recentPayments} = useQuery(['recent-payments'], async () => {
		const {data} = await PaymentController.getRecentPayments();
		return data;
	});

	if (!recentPayments || recentPayments.length === 0) return null;

	const displayedPayments = showAll ? recentPayments : recentPayments.slice(0, 1);
	const remainingCount = recentPayments.length - 1;

	return (
		<Box w='full'>
			<VStack w='full' spacing={4}>
				{displayedPayments.map((billingStatement) => {
					const patientName =
						billingStatement.user && billingStatement.user.id !== me?.id
							? `${billingStatement.user.first_name} ${billingStatement.user.last_name}'s`
							: 'Your';

					return (
						<Box w='full' key={billingStatement.id}>
							<Alert status='success' borderRadius='md'>
								<AlertIcon />
								Thank you! {patientName} payment of $
								{billingStatement.employee_price} has been received for Billing
								Statement #{billingStatement.id}.
							</Alert>
						</Box>
					);
				})}

				{!showAll && remainingCount > 0 && (
					<Button
						variant='ghost'
						size='sm'
						colorScheme='green'
						onClick={() => setShowAll(true)}
					>
						{remainingCount} more
					</Button>
				)}

				{showAll && remainingCount > 0 && (
					<Button
						variant='ghost'
						size='sm'
						colorScheme='green'
						onClick={() => setShowAll(false)}
					>
						Show less
					</Button>
				)}
			</VStack>
		</Box>
	);
};
export default RecentPayments;
